import * as React from 'react';
import { Tooltip } from 'src/component/Tooltip';
import Constants from "../../support/Constants";

const FactoryLeadTimeDisplay = (props) => {
    const { single_product_inventory, isAdditionalLead, single_product, } = props;
    const displayStatus = () => {
        return !Constants.FactoryLeadTime.includes(single_product_inventory?.plifz);
    };
    const renderTooltip = () => (
        <>
            For quantities exceeding available inventory, your estimated delivery is based on supplier lead time,
            shipping method and destination.
        </>
    );
    const renderTooltipAvailable = () => (
        <>
            For quantities exceeding available inventory, your estimated delivery is based on supplier lead time,
            shipping method and destination.
        </>
    );
    const renderInnerMain = (classNameProp = 'fa fa-exclamation-circle') => {
        return (
            <>
                {displayStatus() && !isAdditionalLead &&
                    <Tooltip
                        opener={() => (
                            <i className={classNameProp} />
                        )}
                        content={() => (
                            renderTooltipAvailable()
                        )}
                    />
                }
                {!displayStatus() &&
                    <Tooltip
                        opener={() => <i className={classNameProp} />}
                        content={() => renderTooltip()}
                    />
                }
            </>
        )
    };
    /**
     * Ticket #  : 7470
     * Change #  : Text change for Price Book Part Display text as Not Available
     * Change by : Pankaj
     * Date      : 15 Feb 2023
     */
    const getFactoryLeadTimeText = () => {
        if (single_product && (!single_product.ERPPartNumber || single_product.ERPPartNumberModified)) {
            return 'Not Available';
        }
        return single_product_inventory.plifz ? single_product_inventory.plifz : "Not Available";
    }

    return <>
        {single_product_inventory && single_product_inventory.plifz &&
            <>
                {isAdditionalLead &&
                    <>
                        <div className="d-flex justify-content-between">
                            <div className='additional-title'>Additional Lead Time:</div>
                            <div className='lead-time-digit text-start ms-1'>
                                {getFactoryLeadTimeText()}
                            </div>
                        </div>
                        <div className="d-flex justify-content-between">
                            <div >
                                Lead Time in days: &nbsp;
                            </div>
                            <div>
                                {parseInt(single_product_inventory.plifz) * 7} days
                            </div>
                        </div>
                    </>
                }
                {!isAdditionalLead &&
                    <>
                        <div className="factory-lead">
                            <div className='additional-title'>
                                <span className='me-2'>Factory Lead Time:</span>
                                {renderInnerMain('fa fa-exclamation-circle me-1')}
                            </div>
                            <div className='lead-time-digit text-start ms-1'>
                                {getFactoryLeadTimeText()}
                            </div>
                            <div className="factory-lead">
                                <div >
                                    Lead Time in days: &nbsp;
                                </div>
                                <div>
                                    {parseInt(single_product_inventory.plifz) * 7} days
                                </div>
                            </div>
                        </div>
                    </>}
            </>}

        {!(single_product_inventory && single_product_inventory.plifz) &&
            <>
                {isAdditionalLead &&
                    <>
                        <div className='factory-lead'>
                            <div className='additional-title'>Additional Lead Time:</div>
                            <div className='lead-time-digit text-start ms-1'>
                                Not Available
                            </div>
                        </div>
                    </>
                }
                {!isAdditionalLead &&
                    <>
                        <div className='factory-lead'>
                            <div className='additpROional-title'>
                                <span className='me-2'>Factory Lead Time:</span>
                                {renderInnerMain('fa fa-exclamation-circle')}
                            </div>
                            <div className='lead-time-digit text-start ms-1'>
                                Not Available
                            </div>
                        </div>
                    </>
                }
            </>
        }

    </>;
}

export default FactoryLeadTimeDisplay;